export const CURRENCY_TO_COUNTRY_MAPPING: Record<string, string> = {
  // Major currencies
  USD: 'USA', // US Dollar
  EUR: 'EUR', // Euro (Germany as representative)
  GBP: 'GBR', // British Pound
  JPY: 'JPN', // Japanese Yen
  CHF: 'CHE', // Swiss Franc
  CAD: 'CAN', // Canadian Dollar
  AUD: 'AUS', // Australian Dollar
  NZD: 'NZL', // New Zealand Dollar
  RUB: 'RUS', // Russian Ruble

  // European currencies
  DKK: 'DNK', // Danish Krone
  NOK: 'NOR', // Norwegian Krone
  SEK: 'SWE', // Swedish Krona
  PLN: 'POL', // Polish Zloty
  CZK: 'CZE', // Czech Koruna
  HUF: 'HUN', // Hungarian Forint
  RON: 'ROU', // Romanian Leu
  BGN: 'BGR', // Bulgarian Lev
  HRK: 'HRV', // Croatian Kuna
  RSD: 'SRB', // Serbian Dinar
  MKD: 'MKD', // Macedonian Denar
  BAM: 'BIH', // Bosnia and Herzegovina Convertible Mark
  ALL: 'ALB', // Albanian Lek
  ISK: 'ISL', // Icelandic Krona

  // Asian currencies
  CNY: 'CHN', // Chinese Yuan
  KRW: 'KOR', // South Korean Won
  SGD: 'SGP', // Singapore Dollar
  HKD: 'HKG', // Hong Kong Dollar (using CHN)
  TWD: 'TWN', // New Taiwan Dollar
  THB: 'THA', // Thai Baht
  MYR: 'MYS', // Malaysian Ringgit
  IDR: 'IDN', // Indonesian Rupiah
  PHP: 'PHL', // Philippine Peso
  VND: 'VNM', // Vietnamese Dong
  INR: 'IND', // Indian Rupee
  PKR: 'PAK', // Pakistani Rupee
  BDT: 'BGD', // Bangladeshi Taka
  LKR: 'LKA', // Sri Lankan Rupee
  NPR: 'NPL', // Nepalese Rupee
  MMK: 'MMR', // Myanmar Kyat
  KHR: 'KHM', // Cambodian Riel
  LAK: 'LAO', // Lao Kip
  BND: 'BRN', // Brunei Dollar

  // Middle East and Africa
  SAR: 'SAU', // Saudi Riyal
  QAR: 'QAT', // Qatari Riyal
  KWD: 'KWT', // Kuwaiti Dinar
  BHD: 'BHR', // Bahraini Dinar
  OMR: 'OMN', // Omani Rial
  JOD: 'JOR', // Jordanian Dinar
  LBP: 'LBN', // Lebanese Pound
  ILS: 'ISR', // Israeli Shekel
  EGP: 'EGY', // Egyptian Pound
  TRY: 'TUR', // Turkish Lira
  IRR: 'IRN', // Iranian Rial
  IQD: 'IRQ', // Iraqi Dinar
  AFN: 'AFG', // Afghan Afghani

  // African currencies
  ZAR: 'ZAF', // South African Rand
  NGN: 'NGA', // Nigerian Naira
  KES: 'KEN', // Kenyan Shilling
  UGX: 'UGA', // Ugandan Shilling
  TZS: 'TZA', // Tanzanian Shilling
  ETB: 'ETH', // Ethiopian Birr
  GHS: 'GHA', // Ghanaian Cedi
  MAD: 'MAR', // Moroccan Dirham
  TND: 'TUN', // Tunisian Dinar
  DZD: 'DZA', // Algerian Dinar
  LYD: 'LBY', // Libyan Dinar
  SDG: 'SDN', // Sudanese Pound
  SSP: 'SSD', // South Sudanese Pound
  CDF: 'COD', // Congolese Franc
  XAF: 'CMR', // Central African CFA Franc (Cameroon)
  XOF: 'SEN', // West African CFA Franc (Senegal)
  BWP: 'BWA', // Botswana Pula
  ZMW: 'ZMB', // Zambian Kwacha
  ZWL: 'ZWE', // Zimbabwean Dollar
  MUR: 'MUS', // Mauritian Rupee
  SCR: 'SYC', // Seychellois Rupee
  MGA: 'MDG', // Malagasy Ariary
  MWK: 'MWI', // Malawian Kwacha
  SLL: 'SLE', // Sierra Leonean Leone
  LRD: 'LBR', // Liberian Dollar
  GMD: 'GMB', // Gambian Dalasi
  GNF: 'GIN', // Guinean Franc
  CVE: 'CPV', // Cape Verdean Escudo
  STN: 'STP', // São Tomé and Príncipe Dobra
  AOA: 'AGO', // Angolan Kwanza
  MZN: 'MOZ', // Mozambican Metical

  // American currencies
  MXN: 'MEX', // Mexican Peso
  BRL: 'BRA', // Brazilian Real
  ARS: 'ARG', // Argentine Peso
  CLP: 'CHL', // Chilean Peso
  COP: 'COL', // Colombian Peso
  PEN: 'PER', // Peruvian Sol
  UYU: 'URY', // Uruguayan Peso
  PYG: 'PRY', // Paraguayan Guarani
  BOB: 'BOL', // Bolivian Boliviano
  VES: 'VEN', // Venezuelan Bolívar
  GYD: 'GUY', // Guyanese Dollar
  SRD: 'SUR', // Surinamese Dollar
  TTD: 'TTO', // Trinidad and Tobago Dollar
  JMD: 'JAM', // Jamaican Dollar
  BBD: 'BRB', // Barbadian Dollar
  BZD: 'BLZ', // Belize Dollar
  GTQ: 'GTM', // Guatemalan Quetzal
  HNL: 'HND', // Honduran Lempira
  NIO: 'NIC', // Nicaraguan Córdoba
  CRC: 'CRI', // Costa Rican Colón
  PAB: 'PAN', // Panamanian Balboa
  DOP: 'DOM', // Dominican Peso
  HTG: 'HTI', // Haitian Gourde
  CUP: 'CUB', // Cuban Peso
  XCD: 'DMA', // East Caribbean Dollar (Dominica)

  // Oceania
  FJD: 'FJI', // Fijian Dollar
  PGK: 'PNG', // Papua New Guinean Kina
  SBD: 'SLB', // Solomon Islands Dollar
  VUV: 'VUT', // Vanuatu Vatu
  WST: 'WSM', // Samoan Tala
  TOP: 'TON', // Tongan Paʻanga
  KID: 'KIR', // Kiribati Dollar
  TVD: 'TUV', // Tuvaluan Dollar

  // Special cases
  XDR: 'UNO', // Special Drawing Rights (IMF)
  XAU: 'UNO', // Gold
  XAG: 'UNO', // Silver
  XPT: 'UNO', // Platinum
  XPD: 'UNO', // Palladium
  TOTAL: 'all', // default

  AMD: 'ARM',
  ANG: 'NGL',
  AED: 'ARE',
  ERN: 'ERI',
  UAH: 'UKR',
  // ANG: 'NLD',
};
